export const FREE_CLIENTS = [
  'greenwood',
  'providence',
  'pbh',
  'swedish',
  'summersearch',
  'berkeley',
];
export const BIG_LOGO = 'https://assets.crediblemind.com/images/logo.png';
